<template>
    <div style="text-align: center;">

    <!-- Earth view button -->
    <div style="float: right;">
        <!-- <a href="/b9cc272cfc2456cfa99fb4460b33c56e388f255280e9640a79391815f098940f/xr-demo" id="" class="btn btn-sm btn-primary" type="button"> -->
        <a href="/xr" id="" class="btn btn-sm btn-primary" type="button">
            <!-- <i class="fa-solid fa-earth-americas"></i>
            <span style="padding-left: 10px">Launch LifeChain XR</span> -->
            Launch LifeChain XR
        </a>
    </div>

        <img src="../../assets/images/xr.png"/> 
    </div>
</template>

<script>
    export default {
        name: 'XRDashboard',
        components: {
        },
        data: function () {
            return {
                showmap: false,
                test: "XRDashboard dev",
            };
        },
        props: [],
        watch: {},
        methods: {      

        },
        mounted: function () {

        }
    }
</script>

<style scoped>
    
</style>    

